<template>
  <div :class="classes.liveEvents"><slot /></div>
</template>

<script>
import { defineComponent } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";

const useStyles = createUseStyles({
  "@keyframes flashing": {
    "0%": { opacity: 0 },
    "50%": { opacity: 1 },
    "100%": { opacity: 0 }
  },
  liveEvents: {
    paddingLeft: "8px",
    position: "relative",
    "&:before": {
      position: "absolute",
      content: "''",
      width: "5px",
      height: "5px",
      left: "0px",
      top: "49%",
      transform: "translateY(-50%)",
      backgroundColor: "#d00d00",
      borderRadius: "50%",
      verticalAlign: "middle",
      animationName: "$flashing",
      animationDuration: "1s",
      animationIterationCount: "infinite"
    }
  }
});
export default defineComponent({
  name: "LiveEvents",
  setup() {
    const classesRef = useStyles();

    return {
      classes: classesRef.value
    };
  }
});
</script>
